export default __webpack_public_path__ + "static/media/839.7687a8ff.png";